import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();
const API = '/api';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get(`${API}/auth/profile`)
        .then(res => setUser(res.data))
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('token', res.data.access_token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.access_token}`;
      setUser(res.data.user);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'E-posta veya şifre hatalı' };
    }
  };

  const register = async (userData) => {
    try {
      const res = await axios.post(`${API}/auth/register`, userData);
      localStorage.setItem('token', res.data.access_token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.access_token}`;
      setUser(res.data.user);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Kayıt başarısız' };
    }
  };

  const refreshUser = async () => {
    try {
      const res = await axios.get(`${API}/auth/profile`);
      setUser(res.data);
      return res.data;
    } catch (err) {
      logout();
      return null;
    }
  };

  const loginWithToken = async (token) => {
    try {
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const res = await axios.get(`${API}/auth/profile`);
      setUser(res.data);
      return { success: true };
    } catch (err) {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      return { success: false };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.clear();
    window.location.href = '/login';
  };

  const updateUser = (data) => setUser(prev => ({ ...prev, ...data }));

  // Role helper booleans
  const isSuperAdmin = user?.role === 'super_admin' || user?.role === 'admin';
  const isStoreAdmin = user?.role === 'store_admin';
  const isConsultant = user?.role === 'consultant';
  const isIndividual = user?.role === 'individual';

  // Özel izin kontrolü — super_admin her zaman true döner
  const hasPermission = (perm) =>
    isSuperAdmin || (user?.permissions || []).includes(perm);

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      loginWithToken,
      register,
      logout,
      updateUser,
      refreshUser,
      isSuperAdmin,
      isStoreAdmin,
      isConsultant,
      isIndividual,
      hasPermission,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
